import { useEffect } from "react";
import { useGetExistingCitations } from "../../hooks/use-existing-citations";
import { highlightCitations } from "./highlight-existing-citations";
import { LoadingSpinner } from "../LoadingSpinner";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../components/ui/tooltip";
import { analytics } from "../../index";

export const GetExistingCitations = () => {
  const { citations, isLoading, refetch } = useGetExistingCitations();

  useEffect(() => {
    if (citations) {
      highlightCitations(citations);
    }
  }, [citations]);

  useEffect(() => {
    refetch();
  }, []);

  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger
          onClick={() => {
            if (isLoading) return;
            analytics.track("Clicked Find Citations");
            refetch();
          }}
          className="flex flex-row justify-center items-center w-[124px] h-[36px] gap-1 px-3 py-2 text-gray-500 rounded-md bg-neutral-100"
        >
          {isLoading ? (
            <LoadingSpinner size="15" />
          ) : (
            // <Play size={15} color="gray" />
            <div>Find Citations</div>
          )}
        </TooltipTrigger>
        <TooltipContent align="center" className="border-gray-100">
          Highlight existing citations in the document
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
